import classnames from 'classnames';
import { FC, useMemo } from 'react';

import type { WithErrorTooltipPosition } from '../model';

interface ErrorTooltipArrowProps {
  position: WithErrorTooltipPosition;
}

export const ErrorTooltipArrow: FC<ErrorTooltipArrowProps> = ({ position }) => {
  const verticalArrow = useMemo(() => ['left', 'right'].includes(position), [position]);
  const horizontalArrow = useMemo(() => ['top', 'bottom'].includes(position), [position]);
  const arrowPosition = useMemo(
    () => ({
      'ms-2': horizontalArrow,
      'mt-2': verticalArrow,
    }),
    [horizontalArrow, verticalArrow],
  );
  return <div className={classnames('arrow', arrowPosition)} data-e2e="tooltip-arrow"></div>;
};
